// @ vendors
const Immutable = require('immutable');
// @ constants
const actionTypes = require('constants/actionTypes');

const initialState = Immutable.fromJS({
    ml2: {
        status: null,
        cardLimit: 0,
        scoringStatus: null,
        scoringType: 'digilant',
    },
    jaffar: {
        status: null,
        cardLimit: 0,
        scoringStatus: null,
        scoringType: 'jaffar',
    },
});

const scorings = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case actionTypes.LOAD_ML2:
            return state.merge({
                ml2: action.data,
            });
        case actionTypes.LOAD_JAFFAR:
            return state.merge({
                jaffar: action.data,
            });
        default:
            return state;
    }
};

module.exports = scorings;
